import { render, staticRenderFns } from "./EditFormGpoint.vue?vue&type=template&id=144d7d28"
import script from "./EditFormGpoint.vue?vue&type=script&lang=js"
export * from "./EditFormGpoint.vue?vue&type=script&lang=js"
import style0 from "./EditFormGpoint.vue?vue&type=style&index=0&id=144d7d28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports